// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setWeekYear as fn } from "../setWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setWeekYearWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default setWeekYearWithOptions;
